import DataList from "components/DataList"
import toast from "components/Toast/Toast"
import VerticalTimeline from "components/VerticalTimeLine"
import _ from "lodash"
import moment from "moment"
import "moment/dist/locale/pt-br"
import PropTypes from "prop-types"
import React, { useEffect, useRef, useState } from "react"
import { withTranslation } from "react-i18next"
import { Link } from "react-router-dom"
import Select from "react-select"
import {
  Alert,
  Button,
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Col,
  FormGroup,
  Input,
  Label,
  Media,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
  Table,
  UncontrolledTooltip,
} from "reactstrap"
import {
  downloadFile,
  getQueues,
  getRequestInfo,
  getRequestSteps,
  getRequestsAR,
  markAsSolvedV2,
  moveQueue,
  moveRequest,
  postEncerramento,
} from "services/support/calls"
import SimpleBar from "simplebar-react"
import EncerramentoForm from "./EncerramentoForm"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faFileDownload } from "@fortawesome/free-solid-svg-icons"

moment.locale("pt-br")

const ChamadosModal = props => {
  const { t, isShow, setActiveRequest, activeRequest, resetQueue } = props

  const noteInputRef = useRef(null)
  const [show, setShow] = useState(false)
  const [mitrics, setMitrics] = useState({})
  const [supportInfo, setSupportInfo] = useState(null)
  const [nextStep, setNextStep] = useState(null)
  const [nextQueue, setNextQueue] = useState(null)
  const [anotacoes, setAnotacoes] = useState(null)
  const [isSelected, setIsSelected] = useState(null)
  const [hasDetails, setHasDetails] = useState(null)
  const [isLoading, setIsLoading] = useState(false)
  const [hasMoved, setHasMoved] = useState(null)
  const [missingMetrics, setMissingMetrics] = useState(null)
  const [open, setOpen] = useState(false)
  const [requestsSteps, setRequestsSteps] = useState([])
  const [modalNota, setModalNota] = useState(false)
  const [lockDetalhes, setLockDetalhes] = useState(true)
  const [queues, setQueues] = useState([])
  const [obsModal, setObsModal] = useState(false)
  const [obsModalContent, setObsModalContent] = useState("{}")
  const [closedRequestAnnotations, setClosedRequestAnnotations] = useState(null)

  function DataAdicionar(data_informada, quantidade) {
    var fator = 24 * 60 * 60 * 1000
    var nova_data = new Date(data_informada.getTime() + quantidade * fator)
    nova_data.setHours(0, 0, 0, 0)

    return nova_data
  }
  function DataSubtrair(data_informada, quantidade) {
    var fator = 24 * 60 * 60 * 1000
    var nova_data = new Date(data_informada.getTime() - quantidade * fator)
    nova_data.setHours(0, 0, 0, 0)

    return nova_data
  }
  function FeriadosFixos(ano) {
    var resultados: Number[] = []
    //Array de datas no formato mes/dia.
    //OBS: O primeiro mes é 0 e o último mes é 11
    var datas = [
      [0, 1],
      [3, 21],
      [4, 1],
      [8, 7],
      [9, 12],
      [10, 2],
      [10, 15],
      [11, 25],
    ]

    for (var z = 0; z < datas.length; z++) {
      resultados.push(new Date(ano, datas[z][0], datas[z][1]).getTime())
    }
    return resultados
  }

  function Pascoa(Y) {
    var C = Math.floor(Y / 100)
    var N = Y - 19 * Math.floor(Y / 19)
    var K = Math.floor((C - 17) / 25)
    var I = C - Math.floor(C / 4) - Math.floor((C - K) / 3) + 19 * N + 15
    I = I - 30 * Math.floor(I / 30)
    I =
      I -
      Math.floor(I / 28) *
        (1 -
          Math.floor(I / 28) *
            Math.floor(29 / (I + 1)) *
            Math.floor((21 - N) / 11))
    var J = Y + Math.floor(Y / 4) + I + 2 - C + Math.floor(C / 4)
    J = J - 7 * Math.floor(J / 7)
    var L = I - J
    var M = 3 + Math.floor((L + 40) / 44)
    var D = L + 28 - 31 * Math.floor(M / 4)

    return new Date(Y, M, D)
  }

  const getDescricao = annotations => {
    return (
      annotations?.street +
      "," +
      (annotations?.number || "") +
      "," +
      (annotations?.complement || "") +
      " - " +
      annotations?.neighborhood +
      annotations?.city +
      "," +
      annotations?.state +
      "-" +
      annotations?.postcode
    )
  }

  function getnumDiasUteis(startDate, dataFinal) {
    var numDiasUteis = 0
    var arr1 = startDate.split("-")
    var arr2 = dataFinal.split("-")
    var dataAtual = new Date(arr1[0], arr1[1] - 1, arr1[2])
    dataFinal = new Date(arr2[0], arr2[1] - 1, arr2[2])
    var ano_inicial = dataAtual.getFullYear()
    var ano_final = dataFinal.getFullYear()
    var ano = ano_inicial

    var feriados: Number[] = []
    for (var x = ano; x <= ano_final; x++) {
      //OBS: O primeiro mes é 0 e o último mes é 11
      //Feriados fixos.
      feriados = feriados.concat(FeriadosFixos(ano))
      var data_pascoa = Pascoa(ano)

      //Feriados variaveis de acordo com a data da Pascoa
      feriados.push(data_pascoa.getTime())
      feriados.push(DataAdicionar(data_pascoa, 60).getTime())
      feriados.push(DataSubtrair(data_pascoa, 48).getTime())
      feriados.push(DataSubtrair(data_pascoa, 47).getTime())
      feriados.push(DataSubtrair(data_pascoa, 2).getTime())
      ano++
    }

    while (dataAtual <= dataFinal) {
      if (dataAtual.getDay() !== 0 && dataAtual.getDay() !== 6) {
        if (!feriados.includes(dataAtual.getTime())) {
          numDiasUteis++
        }
      }
      dataAtual = DataAdicionar(dataAtual, 1)
    }
    return numDiasUteis
  }

  function getYearlyWeekNumber(date) {
    let splitedDate = date.split("-")
    let dateObj = new Date(
      +splitedDate[0],
      +splitedDate[1] - 1,
      +splitedDate[2],
      0,
      0,
      0,
      0
    )
    let firstDayYear = new Date(+splitedDate[0], 0, 1, 0, 0, 0, 0)
    let yearDay = (Number(dateObj) - Number(firstDayYear)) / 86400000 + 1
    let weekInYear = +String((yearDay + firstDayYear.getDay() + 1) / 7).split(
      "."
    )[0]
    return weekInYear
  }

  const handleClose = async () => {
    setIsLoading(true)
    try {
      await fecharDetalhes()
      resetQueue()
    } finally {
      setIsLoading(false)
    }
  }

  const fecharDetalhes = async () => {
    try {
      const payload = await postEncerramento(activeRequest.id)
      toast("success", "Chamado fechado")
    } catch (error) {
      console.log(error)
    }
    setActiveRequest(null)
    setModalNota(false)
    setShow(false)
  }

  const handleCloseDialog = () => {
    setNextQueue(null)
    setNextStep(null)
    setAnotacoes(null)
    setOpen(false)
  }

  const handleOpenDialog = () => {
    if (nextQueue || nextStep) {
      setIsSelected(true)
      setOpen(true)
    } else {
      setIsSelected(false)
    }
  }

  const handleMoveQueue = async () => {
    try {
      setIsLoading(true)
      const payload = await moveQueue({
        supportRequestId: activeRequest.id,
        queueId: nextQueue.value,
      })
      setShow(false)
      setOpen(false)
      resetQueue()
    } catch (error) {
      console.log(error)
    } finally {
      setIsLoading(false)
    }
  }

  const handleMoveStep = async () => {
    try {
      setIsLoading(true)
      if (nextStep.value && anotacoes !== null) {
        setHasDetails(true)
        const getLastStep = _.orderBy(
          supportInfo?.payload.steps,
          ["id"],
          ["desc"]
        )[0]
        if (!nextStep.isLast) {
          const stepInfo = {
            stepDetails: anotacoes,
            supportRequestId: activeRequest.id,
            fromStepTypeId: activeRequest.currentStepTypeId,
            toStepTypeId: nextStep.value,
            lastStepId: getLastStep.id,
            queueId: activeRequest.currentQueueTypeId,
          }
          const requestInfo = await moveRequest(stepInfo)
          if (requestInfo.status == "success") {
            handleCloseDialog()
            setHasMoved(true)
            setShow(false)
            resetQueue()
          }
        } else {
          if (
            Object.keys(mitrics).length ==
            Object.keys(supportInfo?.metrics).length
          ) {
            setMissingMetrics(false)
            const metrics = []
            Object.keys(mitrics).map(mitric => {
              metrics.push({ metricId: mitrics[mitric] })
            })
            const stepInfo = {
              supportRequestId: activeRequest.id,
              details: anotacoes,
              toStepTypeId: nextStep.value,
              lastStepId: getLastStep.id,
              metric: metrics,
            }
            const requestInfo = await markAsSolvedV2(activeRequest.id, stepInfo)
            if (requestInfo.status == "success") {
              handleCloseDialog()
              setHasMoved(true)
              setShow(false)
              resetQueue()
              // const timeout = setTimeout(() => {
              //   window.location.reload(false)
              // }, 4000)
            }
          } else {
            setMissingMetrics(true)
          }
        }
      } else {
        setLockDetalhes(false)
        setIsLoading(false)
        setHasDetails(false)
      }
    } catch (error) {
      setLockDetalhes(false)
      setHasMoved(false)
      setIsLoading(false)
    }
  }

  const isJSON = item => {
    let value
    try {
      value = JSON.parse(item)
    } catch (e) {
      return false
    }

    return typeof value === "object" && value !== null
  }

  const getMessage = message => {
    if (typeof message === "string") {
      if (isJSON(message)) {
        return [message, true]
      } else {
        return [message, false]
      }
    }
    if (typeof message === "object") {
      if (message?.message !== undefined) {
        return [
          `${message?.code} - ${message?.status} - ${message?.message}`,
          false,
        ]
      }
      if (message?.msg !== undefined) {
        return [message?.msg, false]
      }
      if (message?.text !== undefined) {
        return [message?.text, false]
      }
    }
    return [message, false]
  }

  useEffect(() => {
    const getRequestInfoCall = async () => {
      try {
        const requestInfo = await getRequestInfo(activeRequest.id)
        requestInfo.newAddress = JSON.parse(
          requestInfo?.payload.support.annotations
        )
        requestInfo.stepOptions = requestInfo?.payload.nextPossibleSteps.map(
          step => ({
            value: step.id,
            label: step.name,
            isLast: step.isLast || false,
          })
        )

        const grupedMetrics = {}
        const aux = requestInfo?.payload.metrics.map(metric => {
          grupedMetrics[metric.dominio] = grupedMetrics[metric.dominio]
            ? grupedMetrics[metric.dominio]
            : []
          grupedMetrics[metric.dominio].push({
            value: metric.id,
            label: metric.name,
          })
        })
        requestInfo.metrics = grupedMetrics
        setSupportInfo(requestInfo)
        setShow(true)
      } catch (error) {
        setActiveRequest(null)
        setModalNota(false)
        setShow(false)
        toast("error", "Falha ao tentar abrir chamado.")
      }
    }
    try {
      getRequestInfoCall()
      fetchQueues()
      latest()
    } catch (error) {
      console.log(error)
    }
  }, [])

  const fetchQueues = async () => {
    const queues = await getQueues()
    setQueues(queues)
  }

  const queuesOptions = queues.map(q => ({ value: q.id, label: q.name }))

  const latest = async () => {
    const { payload } = await getRequestSteps(activeRequest.id)
    const { payload: supports } = await getRequestsAR(activeRequest.orderId)
    if (supports.supports?.closed?.length > 0) {
      const lastIsAuto =
        supports.supports?.closed
          .filter(c => c.currentQueueType.isAuto)
          .slice(-1)[0] || null
      const lastIsFraude =
        supports.supports?.closed
          .filter(c => c.currentQueueType?.name.toLowerCase() === "fraude")
          .slice(-1)[0] || null
      const isFraude =
        supports.supports?.opened
          .filter(c => c.currentQueueType?.name.toLowerCase() === "fraude")
          .slice(-1)[0] || null
      const dates = [lastIsAuto, lastIsFraude, isFraude]
        .sort((a, b) => {
          return moment(b?.createdAt, "YYYY-MM-DD HH:mm:ss").diff(
            a?.createdAt,
            "YYYY-MM-DD HH:mm:ss"
          )
        })
        .filter(a => a !== null)
      if (dates.length > 0) {
        const end = dates[0].annotations
        setClosedRequestAnnotations(end ? JSON.parse(end) : null)
      } else {
        setClosedRequestAnnotations(null)
      }
    } else {
      const isFraude =
        supports.supports?.opened
          .filter(c => c.currentQueueType?.name.toLowerCase() === "fraude")
          .slice(-1)[0] || null
      if (isFraude) {
        setClosedRequestAnnotations(
          isFraude ? JSON.parse(isFraude?.annotations) : null
        )
      } else {
        setClosedRequestAnnotations(null)
      }
    }
    const { requestSteps } = payload
    setRequestsSteps(requestSteps)
  }

  const parseAnnotationsEndereco = annotation => {
    const novoEnd = closedRequestAnnotations
      ? `${closedRequestAnnotations?.street}, ${
          closedRequestAnnotations?.number || ""
        }, ${closedRequestAnnotations?.complement || ""} - ${
          closedRequestAnnotations?.neighborhood
        } - ${closedRequestAnnotations?.city}, ${
          closedRequestAnnotations?.state
        } - ${closedRequestAnnotations?.postcode}`
      : ""
    const ann = annotation ? JSON.parse(annotation) : null
    return novoEnd
      ? novoEnd
      : ann !== null
      ? `${ann.street}, ${ann.number || ""} - ${ann.complement} - ${
          ann.neighborhood
        } - ${ann.city}, ${ann.state} - ${ann.postcode}`
      : ""
  }

  const parseAnnotationsAnotacao = annotation => {
    const ann = annotation ? JSON.parse(annotation) : null
    return ann !== null
      ? ann?.anotacao !== undefined
        ? `${ann.anotacao}`
        : ""
      : ""
  }

  const nextStepRef = useRef()
  const nextFilaRef = useRef()

  const [canDownload, setCanDownload] = useState(true)

  const getFileName = annotation => {
    const ann = annotation ? JSON.parse(annotation) : null
    return ann !== null ? (ann?.fileName ? ann?.fileName : "") : ""
  }

  const download = async ({ filename }) => {
    try {
      setCanDownload(false)
      const payload = await downloadFile({ filename })
      const url = window.URL.createObjectURL(new Blob([payload]))
      const link = document.createElement("a")
      link.href = url
      const type = filename.split(".").pop()
      const timestamp = moment().format("DD_MM_YYYY_HH_mm")
      link.setAttribute("download", filename)
      document.body.appendChild(link)
      link.click()
      setCanDownload(true)
    } catch (error) {}
  }

  return (
    <>
      <Modal
        isOpen={open}
        size="md"
        centered
        backdrop="static"
        aria-labelledby="contained-modal-title-vcenter"
        onClosed={handleCloseDialog}
      >
        <ModalHeader>Confirmação</ModalHeader>
        <ModalBody>
          <Row>
            <Col>
              {supportInfo && nextStep?.isLast && (
                <FormGroup controlid="statusSafra">
                  <Label>Proxima etapa </Label>
                  {Object.keys(supportInfo?.metrics).map((key, index) => {
                    return (
                      <React.Fragment key={"metrics" + index}>
                        <Select
                          classNamePrefix="reactSelect"
                          key={"metricasKey" + index}
                          options={supportInfo?.metrics[key]}
                          placeholder="Selecione a metrica"
                          onChange={e => {
                            const aux = mitrics
                            mitrics[index + 1] = e.value
                            setMitrics(mitrics)
                          }}
                        />{" "}
                        <div style={{ paddingBottom: 10 }}></div>
                      </React.Fragment>
                    )
                  })}
                </FormGroup>
              )}
            </Col>
            {hasDetails === false && (
              <Alert color="warning">Anotação obrigatoria.</Alert>
            )}
            {missingMetrics === true && (
              <Alert color="warning">Métricas obrigatorias.</Alert>
            )}
            <label>Adicione anotações à solicitação de suporte:</label>
          </Row>
          <Row>
            <Col>
              <textarea
                className="form-control"
                rows="5"
                onChange={e => {
                  setAnotacoes(e?.target.value)
                }}
              />
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button
            variant="primary"
            onClick={() => {
              if (nextStep?.value) {
                handleMoveStep()
              } else {
                handleMoveQueue()
              }
            }}
            disabled={isLoading}
          >
            Confirmar
          </Button>
          <Button
            variant="danger"
            onClick={handleCloseDialog}
            disabled={isLoading}
          >
            Fechar
          </Button>
        </ModalFooter>
      </Modal>
      <Modal
        isOpen={show}
        onClosed={handleClose}
        size="xl"
        scrollable={true}
        backdrop="static"
        centered
        style={{ opacity: open ? "0.7" : 1, outline: "1px" }}
      >
        <ModalHeader>
          Chamado em andamento
          <button
            type="button"
            onClick={handleClose}
            className="close"
            data-dismiss="modal"
            aria-label="Close"
            disabled={isLoading}
          >
            <span aria-hidden="true">&times;</span>
          </button>
          {hasMoved === false && (
            <Alert color="warning">
              Erro ao andar com o chamado, tente novamente após fechar e abrir.
            </Alert>
          )}
          {hasMoved === true && (
            <Alert color="success">Chamado foi atualizado com sucesso!</Alert>
          )}
        </ModalHeader>
        <SimpleBar style={{ height: "80vh" }}>
          <ModalBody>
            {isSelected === false && (
              <Row>
                <Alert color="warning">
                  Favor escolher a proxima etapa do chamado.
                </Alert>
              </Row>
            )}
            <Row>
              <Col>
                <Card outline color="dark" className="border">
                  <CardHeader tag={"h4"} className="bg-primary text-white">
                    Solicitação
                  </CardHeader>
                  <CardBody>
                    <Row>
                      <Col>
                        <Table>
                          <thead>
                            <tr>
                              <th>ID</th>
                              <th>AR</th>
                              <th>Empresa</th>
                              <th>Situação</th>
                              <th>Atendente</th>
                              <th>Criação</th>
                              <th>Canal</th>
                              <th>Transportadora</th>
                              <th>Tipo</th>
                              <th>Anexo</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>{activeRequest.id}</td>
                              <td>{activeRequest.order.shippingTrackerCode}</td>
                              <td>{activeRequest.order.nameCompany}</td>
                              <td>
                                {
                                  supportInfo?.payload.support.currentStepType
                                    ?.name
                                }
                              </td>
                              <td>{activeRequest.support?.employee?.name}</td>
                              <td>
                                {activeRequest.createdAt
                                  ? moment(
                                      activeRequest.createdAt,
                                      "YYYY-MM-DD"
                                    ).format("DD/MM/YYYY")
                                  : "-"}
                              </td>
                              <td>{activeRequest.channel?.name}</td>
                              <td>
                                {activeRequest.order.shippingCompany?.name}
                              </td>
                              <td>{activeRequest.type?.name}</td>
                              <td>
                                {getFileName(activeRequest.annotations) !==
                                  "" && (
                                  <button
                                    disabled={
                                      !canDownload ||
                                      getFileName(activeRequest.annotations) ===
                                        ""
                                    }
                                    className="btn btn-link"
                                    onClick={() =>
                                      download({
                                        filename: getFileName(
                                          activeRequest.annotations
                                        ),
                                      })
                                    }
                                  >
                                    [ <FontAwesomeIcon icon={faFileDownload} />{" "}
                                    Baixar ]
                                  </button>
                                )}
                              </td>
                            </tr>
                          </tbody>
                        </Table>
                      </Col>
                    </Row>
                    <Row className="mb-1">
                      <Label
                        htmlFor="enderecoAtual"
                        className="col-md-1 col-form-label"
                      >
                        End Original
                      </Label>
                      <Col md={5}>
                        <Input
                          className="form-control"
                          type="text"
                          defaultValue={`${
                            activeRequest.order.shippingStreet
                          }, ${
                            activeRequest.order.shippingStreetNumber || ""
                          } - ${
                            activeRequest.order.shippingAddressComplement || ""
                          } - ${activeRequest.order.shippingNeighborhood} - ${
                            activeRequest.order.shippingCity
                          }, ${activeRequest.order.shippingState} - ${
                            activeRequest.order.shippingPostcode
                          }`}
                          readOnly
                        />
                      </Col>

                      <Label
                        htmlFor="novoEnd"
                        className="col-md-1 col-form-label"
                      >
                        Novo Endereço
                      </Label>
                      <Col md={5}>
                        <Input
                          className="form-control"
                          type="text"
                          defaultValue={parseAnnotationsEndereco(
                            activeRequest.annotations
                          )}
                          readOnly
                        />
                      </Col>
                    </Row>
                    <Row className="mb-1">
                      <Label
                        htmlFor="descricao"
                        className="col-md-1 col-form-label"
                      >
                        Descrição
                      </Label>
                      <Col md={5}>
                        <Input
                          className="form-control"
                          type="text"
                          defaultValue={
                            parseAnnotationsAnotacao(
                              activeRequest.annotations
                            ) || ""
                          }
                          readOnly
                        />
                      </Col>

                      <Label htmlFor="Nome" className="col-md-1 col-form-label">
                        Nome
                      </Label>
                      <Col md={2}>
                        <Input
                          className="form-control"
                          type="text"
                          defaultValue={activeRequest.order.clientName}
                          readOnly
                        />
                      </Col>

                      <Label htmlFor="CPF" className="col-md-1 col-form-label">
                        CPF
                      </Label>
                      <Col md={2}>
                        <Input
                          className="form-control"
                          type="text"
                          defaultValue={activeRequest.order.clientDocumentId}
                          readOnly
                        />
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>
            </Row>
            <Row>
              <Col>
                <Card outline color="dark" className="border">
                  <CardHeader tag={"h4"} className="bg-primary text-white">
                    Retorno
                  </CardHeader>
                  <CardBody>
                    <Row>
                      <Col>
                        <Card outline color="dark" className="border">
                          <CardHeader
                            tag={"h4"}
                            className="bg-primary text-white"
                          >
                            Histórico
                          </CardHeader>
                          <CardBody>
                            <Table
                              striped
                              bordered
                              hover
                              size="sm"
                              responsive="xl"
                              style={{ fontSize: "12px" }}
                            >
                              <thead>
                                <tr>
                                  <th>Situação</th>
                                  <th>Usuário</th>
                                  <th>Fila</th>
                                  <th>Dt. Criação</th>
                                  <th>Dt. Tratativa</th>
                                  <th>Tempo Tratativa</th>
                                  <th>Observação</th>
                                </tr>
                              </thead>
                              <tbody>
                                {requestsSteps.map(requestStep => (
                                  <tr key={`request-${requestStep.id}`}>
                                    <td>
                                      {requestStep.fromStepType?.name || "-"}
                                    </td>
                                    <td>{requestStep.resolver?.name || "-"}</td>
                                    <td>{requestStep?.queue?.name || "-"}</td>
                                    <td>
                                      {requestStep.createdAt
                                        ? moment(
                                            requestStep.createdAt,
                                            "YYYY-MM-DD HH:mm:ss"
                                          )
                                            .add(-3, "hours")
                                            .format("DD/MM/YYYY HH:mm:ss")
                                        : "-"}
                                    </td>
                                    <td>
                                      {requestStep.resolvedBy
                                        ? moment(
                                            requestStep.updatedAt,
                                            "YYYY-MM-DD HH:mm:ss"
                                          )
                                            .add(-3, "hours")
                                            .format("DD/MM/YYYY HH:mm:ss")
                                        : "-"}
                                    </td>

                                    <td>
                                      {requestStep.resolvedBy
                                        ? getnumDiasUteis(
                                            moment(
                                              requestStep.createdAt
                                            ).format("YYYY-MM-DD"),
                                            moment(
                                              requestStep.updatedAt
                                            ).format("YYYY-MM-DD")
                                          ) - 1
                                        : "-"}
                                    </td>
                                    <td>
                                      {requestStep?.queue?.name ===
                                      "Automatica" ? (
                                        <ul className="list-unstyled hstack gap-1 mb-0 justify-content-center">
                                          <li>
                                            <a
                                              target="_blank"
                                              className={`btn btn-sm btn-secondary`}
                                              onClick={() => {
                                                setObsModalContent(
                                                  JSON.parse(
                                                    requestStep.details || "{}"
                                                  )
                                                )
                                                setObsModal(true)
                                              }}
                                            >
                                              <i
                                                className="mdi mdi-format-list-bulleted"
                                                id={`detailToolTip${requestStep.id}`}
                                              ></i>
                                            </a>
                                            <UncontrolledTooltip
                                              placement="top"
                                              target={`detailToolTip${requestStep.id}`}
                                            >
                                              Observação
                                            </UncontrolledTooltip>
                                          </li>
                                        </ul>
                                      ) : (
                                        requestStep.details
                                      )}
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </Table>
                          </CardBody>
                        </Card>
                      </Col>
                    </Row>
                    <Row>
                      {/* supportInfo?.payload.support.currentStepType
                                    ?. */}

                      {supportInfo?.payload.nextPossibleSteps.length != 0 &&
                        !(activeRequest.currentQueueType?.isAuto === true) &&
                        supportInfo != null &&
                        !supportInfo?.payload.support.currentStepType
                          ?.isLast && (
                          <Col sm={3}>
                            <Card>
                              <CardHeader
                                tag={"h4"}
                                className="bg-primary text-white"
                              >
                                Próxima etapa
                              </CardHeader>
                              <CardBody>
                                {supportInfo && (
                                  <>
                                    {activeRequest.currentStepType?.name && (
                                      <Label>
                                        Step atual:{" "}
                                        <b>
                                          {activeRequest.currentStepType?.name}
                                        </b>
                                      </Label>
                                    )}

                                    <Select
                                      classNamePrefix="reactSelect"
                                      isDisabled={nextQueue !== null}
                                      isClearable
                                      ref={nextStepRef}
                                      options={supportInfo?.stepOptions.filter(
                                        s =>
                                          s.value !==
                                          activeRequest.currentStepTypeId
                                      )}
                                      placeholder="Selecione a proxima etapa"
                                      onChange={e => {
                                        nextStepRef.current.value = e
                                        setNextStep(e)
                                      }}
                                    />
                                  </>
                                )}
                                <br></br>
                              </CardBody>
                            </Card>
                          </Col>
                        )}

                      {!supportInfo?.payload.support.currentStepType?.isLast &&
                        !activeRequest.currentQueueType?.isAuto === true && (
                          <Col sm={3}>
                            <Card>
                              <CardHeader
                                tag={"h4"}
                                className="bg-primary text-white"
                              >
                                Próxima Fila
                              </CardHeader>
                              <CardBody>
                                {activeRequest.currentQueueType?.name && (
                                  <Label>
                                    Fila atual:{" "}
                                    <b>
                                      {activeRequest.currentQueueType?.name}
                                    </b>
                                  </Label>
                                )}
                                <Select
                                  classNamePrefix="reactSelect"
                                  isDisabled={nextStep !== null}
                                  isClearable
                                  ref={nextFilaRef}
                                  options={queuesOptions.filter(
                                    q =>
                                      q.value !==
                                      activeRequest.currentQueueTypeId
                                  )}
                                  placeholder="Selecione a proxima fila"
                                  onChange={e => {
                                    nextFilaRef.current.value = e
                                    setNextQueue(e)
                                  }}
                                />
                                <br></br>
                              </CardBody>
                            </Card>
                          </Col>
                        )}
                      <Col>
                        <Card>
                          <CardHeader
                            tag={"h4"}
                            className="bg-primary text-white"
                          >
                            Anotações
                          </CardHeader>
                          <CardBody className="p-0">
                            <SimpleBar style={{ height: "200px" }}>
                              <Table
                                striped
                                bordered
                                hover
                                size="sm"
                                responsive="xl"
                                style={{ fontSize: "12px" }}
                              >
                                <thead>
                                  <tr>
                                    <th>Horário</th>
                                    <th>Usuário</th>
                                    <th>Nota</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {activeRequest.details &&
                                    Object.entries(
                                      JSON.parse(activeRequest.details)
                                    ).map(([key, value], idx) => {
                                      const [msg, hasObj] = getMessage(
                                        value?.message
                                      )
                                      if (hasObj) {
                                        let ruleFraude
                                        ruleFraude = JSON.parse(msg)
                                        if (ruleFraude?.rule === "rule_1") {
                                          ruleFraude[
                                            "description"
                                          ] = `CEP: ${ruleFraude?.extras}`
                                        }
                                        if (ruleFraude?.rule === "rule_2") {
                                          ruleFraude["description"] = [
                                            "Testes realizados: ",
                                          ]
                                          ruleFraude["description"].push(
                                            ...ruleFraude?.extras.map(
                                              el =>
                                                `Número: ${el?.Number}. CEP: ${el?.ZipCode}. `
                                            )
                                          )
                                        }
                                        return (
                                          <tr key={idx}>
                                            <td>
                                              {moment(
                                                key,
                                                "YYYY-MM-DD HH:mm:ss"
                                              ).format("DD/MM/YYYY HH:mm")}
                                            </td>
                                            <td>{value?.userName}</td>
                                            <td>{ruleFraude?.description}</td>
                                          </tr>
                                        )
                                      } else {
                                        return (
                                          <tr key={idx}>
                                            <td>
                                              {moment(
                                                key,
                                                "YYYY-MM-DD HH:mm:ss"
                                              ).format("DD/MM/YYYY HH:mm")}
                                            </td>
                                            <td>{value?.userName}</td>
                                            <td>{msg}</td>
                                          </tr>
                                        )
                                      }
                                    })}
                                </tbody>
                              </Table>
                            </SimpleBar>
                          </CardBody>
                        </Card>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </ModalBody>
        </SimpleBar>
        <ModalFooter>
          <Button
            color="primary"
            onClick={handleOpenDialog}
            disabled={isLoading}
          >
            Alterar
          </Button>
          <Button color="secondary" onClick={handleClose} disabled={isLoading}>
            Fechar
          </Button>
        </ModalFooter>
      </Modal>
      <Modal
        isOpen={obsModal}
        toggle={() => {
          setObsModal(!obsModal)
        }}
        size="lg"
        centered
      >
        <ModalHeader>
          Observação
          <button
            type="button"
            onClick={() => {
              setObsModal(false)
            }}
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col>
              <Card>
                <CardBody>
                  <VerticalTimeline
                    events={
                      Object.keys(obsModalContent)?.length === 0
                        ? []
                        : Array.from(
                            Object.keys(obsModalContent).map((ev, idx) => {
                              const [msg, isJson] = getMessage(
                                obsModalContent[ev]?.message
                              )
                              if (
                                Object.keys(obsModalContent).length ===
                                idx + 1
                              ) {
                                return {
                                  active: true,
                                  title: ev,
                                  description: msg,
                                  isJson: isJson,
                                }
                              } else {
                                return {
                                  active: false,
                                  title: ev,
                                  description: msg,
                                  isJson: isJson,
                                }
                              }
                            })
                          )
                    }
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </ModalBody>
      </Modal>
      {/* <Modal isOpen={modalNota} centered size="md" backdrop="static">
        <ModalHeader>Motivo de não alteração</ModalHeader>
        <ModalBody
          style={{ minHeight: 300 }}
          className="d-flex w-100 justify-content-center align-items-center"
        >
          <EncerramentoForm onSubmit={note => fecharDetalhes(note)} />
        </ModalBody>
      </Modal> */}
    </>
  )
}

ChamadosModal.propTypes = {
  t: PropTypes.any,
  isShow: PropTypes.bool,
  setActiveRequest: PropTypes.func,
  activeRequest: PropTypes.any,
  resetQueue: PropTypes.func,
}

export default withTranslation()(ChamadosModal)
